import api from './client';

/** Добавить задачу в очередь на рассмотрение. */
export async function addTaskToInbox({ taskId, lessonSessionId, studentId, note } = {}) {
  const body = { task_id: taskId };
  if (lessonSessionId != null && lessonSessionId !== '') {
    body.lesson_session_id = Number(lessonSessionId);
  }
  if (studentId != null && studentId !== '') {
    body.student_id = Number(studentId);
  }
  if (note != null) body.note = note;
  const res = await api.post('/teacher/task-inbox/', body);
  return res.data;
}

/** Пометить запись очереди как готовую (снять с очереди). */
export async function markInboxItemDone(itemId) {
  const res = await api.patch(`/teacher/task-inbox/${itemId}/`, { status: 'done' });
  return res.data;
}

/** Есть ли задача в открытой очереди. */
export async function fetchInboxByTask(taskId) {
  const res = await api.get(`/teacher/task-inbox/by-task/${taskId}/`);
  return res.data;
}
